import React, { useMemo } from "react";
import { Typography } from "@mui/material";

import PackageCurrencyAmount from "../PackageCurrencyAmount";
import { subscriptionHelper } from "@/features/subscriptions/helpers/subscriptionHelper";
import { subscriptionPlanFeeType } from "@/config/constants";
import RpRowHtml from "@/components/rowHtml/RpRowHtml";

export default function PackageCard({ plan }) {
  const renderCoast = useMemo(() => {
    const showCadAmount = subscriptionHelper.hasUsdCadCurrency(plan);
    const getCoastContent = (
      amount,
      cadAmount,
      extraCharge,
      cadExtraCharge,
      type
    ) => (
      <>
        <div className="media-fee">
          <Typography component="h5" variant="h3" className="total">
            <PackageCurrencyAmount
              value={amount}
              cadValue={cadAmount}
              showCadAmount={showCadAmount}
              fixedDecimalScale={false}
            />
          </Typography>
          <Typography className="total-info ml-2">
            {type === "media" || type === "both" ? "media cost" : "fee"}
            <br /> per month
          </Typography>
        </div>
        {type === "both" && (
          <div className="subscription-fee ml-4">
            <Typography component="h5" variant="h4" className="total">
              +
              <PackageCurrencyAmount
                value={extraCharge}
                cadValue={cadExtraCharge}
                showCadAmount={showCadAmount}
                fixedDecimalScale={false}
              />
            </Typography>
            <Typography className="total-info ml-2">
              fee <br />
              per month
            </Typography>
          </div>
        )}
      </>
    );

    if (plan.fees_type === subscriptionPlanFeeType.SUB_FEE_AND_MEDIA_COST) {
      return getCoastContent(
        plan.amount,
        plan.cad_amount,
        plan.extra_charge,
        plan.cad_extra_charge,
        "both"
      );
    } else if (plan.fees_type === subscriptionPlanFeeType.SUB_FEE_ONLY) {
      return getCoastContent(
        plan.extra_charge,
        plan.cad_extra_charge,
        null,
        null,
        "subscription"
      );
    } else {
      return getCoastContent(plan.amount, plan.cad_amount, null, null, "media");
    }
  }, [plan]);

  return (
    <>
      <div
        className={`card package-card h-100 ${
          plan.is_recommended ? "recommended_package" : ""
        } ${plan.is_brand_match ? "brand-match-card" : ""}`}
      >
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <Typography component="h4" variant="h6" className="name">
              {plan.title}{" "}
            </Typography>
            {plan.is_recommended ? (
              <div className="text-center mb-3">
                <span className="recommended">Recommended</span>
              </div>
            ) : null}
          </div>

          {renderCoast}
          <RpRowHtml className="description mt-3" html={plan.description} />
        </div>
      </div>
    </>
  );
}
